import {
  Box,
  Typography,
  Avatar,
  Chip,
  Divider,
  useTheme,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import { DateTime } from "luxon";
import { getStatusColor } from "./utils/statusHelpers";

interface ContactInfoSectionProps {
  firstName?: string;
  lastName?: string;
  phoneNumber: string;
  city?: string;
  state?: string;
  reviewStatus?: string;
  timestamp: DateTime;
}

export const ContactInfoSection = ({
  firstName,
  lastName,
  phoneNumber,
  city,
  state,
  reviewStatus,
  timestamp,
}: ContactInfoSectionProps) => {
  const theme = useTheme();

  const formattedDate = timestamp.toLocaleString({
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });

  const displayName =
    firstName && lastName ? `${firstName} ${lastName}` : "Unknown";

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
        <Avatar
          sx={{
            bgcolor: theme.palette.primary.main,
            mr: 2,
          }}
        >
          {firstName ? firstName[0] : <PersonIcon />}
        </Avatar>
        <Typography variant="h6" component="div">
          {displayName}
        </Typography>
        <div style={{ flex: 1 }} />
        <Chip
          label={reviewStatus || "pending"}
          color={
            getStatusColor(reviewStatus) as "success" | "error" | "warning"
          }
          size="small"
        />
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Box
          component="span"
          sx={{ display: "inline-flex", alignItems: "center" }}
        >
          <PhoneIcon fontSize="small" sx={{ mr: 0.5 }} />
          <Typography variant="body2" color="text.secondary">
            {phoneNumber}
          </Typography>
        </Box>
        {city && state && (
          <Box
            component="span"
            sx={{ display: "inline-flex", alignItems: "center" }}
          >
            <LocationOnIcon fontSize="small" sx={{ mr: 0.5 }} />
            <Typography variant="body2" color="text.secondary">
              {city}, {state}
            </Typography>
          </Box>
        )}
      </Box>

      <Divider sx={{ my: 2 }} />
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", mb: 1 }}
      >
        Received: {formattedDate}
      </Typography>
    </>
  );
};
